// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2foGI","buttons":"PendingPaymentAlert_buttons__xX9Ae"};